import { addHours, format, set } from "date-fns"
import { utcToZonedTime } from 'date-fns-tz'
import { ja } from 'date-fns/locale'
import { DeleteHeader, GetHeader, PPHeader } from "../common"

const URL = process.env.REACT_APP_API_QA!

export interface typeQaList {
  [name: string]: string | null | Date | number
}
export interface typeUserInfoList {
  [name: string]: string | null | Array<{ [name: string]: string | null }>
}

export interface typeQaContent {
  qaNo: string,
  qaStartSt: string,
  qaKindClsCd: string | null,
  qaWayClsCd: string,
  qaTitle: string,
  qPersonCd: string,
  qaContents: string | null,
  qaTotalTime: number | null,
  qaStatusClsCd: string,
  qaCloseSt: string | null,
  answerDate: string | null,
  relatedQaNo: string | null,
  keiyakuNo: string,
  custmNo: string,
  attachedFile: string | null,
  faqFlgClsCd: string | null,
  outKeiyakuCustmNm: string | null,
  outKeiyakuPersonNm: string | null,
  qaSeCd: string,
  createDate: string | null,
  createCd: string | null,
  updateDate: string | null,
  updateCd: string | null,
  custmDepNo: string,
  outKeiyakuTel: string | null,
  incidentUse: number | null,
  incidentAddCount: number | null,
  incidentAddFlg: string | null,
  qaKindClsName: string | null,
  qaWayClsName: string | null,
  qPersonName: string,
  qaStatusClsName: string,
  keiyakuClsCd: string,
  keiyakuClsName: string,
  incidentCount: number | null,
  incidentValidAddCount: number | null,
  incidentUsedCount: number | null,
}

export interface typeQaEnvironment {
  qaNo: string,
  ssVersionClsCd: string | null,
  serverOsClsCd: string | null,
  serverDbClsCd: string | null,
  serverConnectClsCd: string | null,
  serverAsClsCd: string | null,
  clientOsClsCd: string | null,
  clientDbClsCd: string | null,
  createDate: string,
  createCd: string,
  updateDate: string | null,
  updateCd: string | null,
}
export interface typeQaRest {
  qaNo: string,
  qaFlg: string,
  answerClsCd: string,
  answerContents: string,
  aPersonCd: string,
  attachedFile: string | null,
  attachedFileData?: string | null,
  answeSt: Date,
  createDate: string | null,
  createCd: string | null,
  updateDate: string | null,
  updateCd: string | null,
  qaSerialNo: string,
  note: string | null,
  attachedFile2: string | null,
  attachedFile2Data?: string | null,
  attachedFile3: string | null,
  attachedFile3Data?: string | null,
  aPersonName: string,
  qaStatusClsCd: string,
}

interface postForm {
  qaStartSt: string,
  qaKindClsCd: string,
  qaWayClsCd: string,
  qaTitle: string,
  qPersonCd: string,
  qaContents: string,
  qaStatusClsCd: string,
  relatedQaNo: string,
  keiyakuNo: string,
  custmNo: string,
  attachedFile: string,
  attachedFileData: string,
  createCd: string,
  custmDepNo: string,
  ssVersionClsCd: string,
  serverOsClsCd: string,
  serverDbClsCd: string,
  serverConnectClsCd: string,
  serverAsClsCd: string,
  clientOsClsCd: string,
  clientDbClsCd: string
}
export interface typeUpdateForm {
  qaNo: string,
  qaFlg: string,
  answerClsCd: string,
  answerContents: string,
  aPersonCd: string,
  attachedFile: string,
  attachedFileData: string,
  attachedFile2: string,
  attachedFile2Data: string,
  attachedFile3: string,
  attachedFile3Data: string,
  answeSt: string,
  createCd: string,
  qaStatusClsCd: string,
  note: string,
  qaSerialNo: string,
  createDate: string,
  updateDate: string,
  updateCd: string,
  qaKindClsCd: string,
  qaTotalTime: number | null,
  incidentUse: number | null,
  incidentAddFlg: string | null,
}

export interface typeCustomerList {
  userCd: string,
  termCd: string | null,
  startDate: Date | null,
  endDate: Date | null,
  telephoneNumber: Date | null,
  mobileNumber: string | null,
  faxNumber: string | null,
  extensionNumber: string | null,
  extensionFaxNumber: string | null,
  countryCd: string | null,
  zipCode: string | null,
  emailAddress1: string | null,
  emailAddress2: string | null,
  mobileEmailAddress: string | null,
  url: string | null,
  localeId: string | null,
  userName: string,
  userNameSyllabary: string | null,
  userNameEng: string | null,
  address: string | null,
  companyCd: string,
  departmentCd: string,
  departmentName: string,
  departmentNameSyllabary: string | null,
  departmentNameEng: string | null,
  address1: string | null,
  address2: string | null,
  notes: string | null,
  customerName: string,
}

export interface typeputForm {
  qaNo: string | undefined,
  qaStartSt: string | undefined,
  qaKindClsCd: string | undefined | null,
  qaWayClsCd: string | undefined,
  qaTitle: string | undefined,
  qPersonCd: string | undefined,
  qaContents: string | undefined | null,
  qaTotalTime: number | undefined | null,
  qaStatusClsCd: string | undefined,
  qaCloseSt: string | Date | undefined | null,
  answerDate: string | Date | undefined | null,
  relatedQaNo: string | undefined | null,
  keiyakuNo: string | undefined,
  custmNo: string | undefined,
  attachedFile: string | undefined,
  attachedFileData: string | undefined,
  faqFlgClsCd: string | undefined | null,
  outKeiyakuCustmNm: string | undefined | null,
  outKeiyakuPersonNm: string | undefined | null,
  qaSeCd: string | undefined,
  createDate: string | undefined | null,
  createCd: string | undefined | null,
  updateDate: string | undefined | null,
  updateCd: string | undefined | null,
  custmDepNo: string | undefined,
  outKeiyakuTel: string | undefined | null,
  incidentUse: number | undefined | null,
  incidentAddCount: number | undefined | null,
  incidentAddFlg: string | undefined | null,
  ssVersionClsCd: string | undefined | null,
  serverOsClsCd: string | undefined | null,
  serverDbClsCd: string | undefined | null,
  serverConnectClsCd: string | undefined | null,
  serverAsClsCd: string | undefined | null,
  clientOsClsCd: string | undefined | null,
  clientDbClsCd: string | undefined | null,
}

export interface typeVisits {
  keiyakuKikan: string,
  qaNo: string,
  answerSt: Date,
  answerStJ: Date,
  aPersonCd: string,
  aPersonName: string,
  answerClsCd: string,
  answerClsName: string,
  qaStatusClsCd: string,
  qaStatusClsName: string,

}


//016 QA一覧取得
export const getQAList = async (userid: string, tokenUser: string, token: string, role: string, qano: string, keiyakuno: string, qastatusclscd: string, qastart: Date | null, qaend: Date | null, keyword: string, keiyakuclsCd: string, secd: string): Promise<typeQaList[]> => {
  const dateStartFormat = (datevalue: Date): string => {
    const setdate = set(utcToZonedTime(datevalue, 'Asia/Tokyo'), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 })
    return format(setdate, 'yyyy-MM-dd HH:mm:ss')

  }
  const dateEndFormat = (datevalue: Date): string => {
    const setdate = set(utcToZonedTime(datevalue, 'Asia/Tokyo'), { hours: 23, minutes: 59, seconds: 59, milliseconds: 999 })
    return format(setdate, 'yyyy-MM-dd HH:mm:ss')
  }
  const params = new URLSearchParams()
  params.set('userId', userid)
  params.set('qaNo', qano.replace(/_/g, ''))
  params.set('keiyakuNo', keiyakuno)
  params.set('qaStatus', qastatusclscd)
  params.set('qaStart', qastart ? dateStartFormat(qastart) : '')
  params.set('qaEnd', qaend ? dateEndFormat(qaend) : '')
  params.set('keyWord', keyword)
  params.set('keiyakuClsCd', keiyakuclsCd)
  params.set('seCd', secd)
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/qas?${params.toString()}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {//データが存在する
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    for (const reso of res) {
      for (const [key, value] of Object.entries(reso)) {//日付フィールドDate型変換
        if (key === 'createDate' || key === 'updateDate') {
          if (value && typeof value === 'string') {
            reso[key] = new Date(value)
          }
        }
      }
    }
    return res
  })
  return res
}

//017 ユーザー情報取得 完了
export const getUserInfoList = async (userid: string, tokenUser: string, token: string, role: string): Promise<typeUserInfoList> => {
  const header = GetHeader(tokenUser, token, role)
  const res = await fetch(`${URL}/users/${userid}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//018 QA基本情報登録　完了
export const postQaContent = async (userid: string, token: string, role: string, form: postForm): Promise<boolean> => {
  //form to JSON
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'relatedQaNo') {
        obj[key] = value.replace(/_/g, '').replace(/ /g, '')
      } else if (key === 'qaContents') {
        obj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
      } else {
        obj[key] = value
      }
    }
  }
  const jsondata = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsondata, 'POST')
  const res = await fetch(`${URL}/qabt`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//019 添付ファイル取得サービス 完了
export const getAttachedFile = async (userid: string, token: string, role: string, attachedfilename: string): Promise<string> => {
  const hyphenPath = attachedfilename.replace(/\//g, '-')
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/attachedfile/${hyphenPath}`, header).then(response => {
    if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => res.attachedFileData)
  return res
}

//020 QA基本情報取得 完了
export const getQaContent = async (userid: string, token: string, role: string, qano: string): Promise<any> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/qabt/${qano}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    if (res) {
      for (const [key, value] of Object.entries(res)) {//日付フィールドDate型変換
        if (key === 'relatedQaNo') {
          if (value && typeof value === 'string') {
            res[key] = value.replace(/ /g, '')
          }
        }
      }
    }
    return res
  })
  return res
}

//021 QA環境情報取得 完了
export const getQaEnvironment = async (userid: string, token: string, role: string, qano: string): Promise<typeQaEnvironment> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/qaenvt/${qano}`, header).then(response => {
    if (response.status === 204) {
      return null
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//022 QAレスポンス一覧取得 完了
export const getQaRest = async (userid: string, token: string, role: string, qano: string): Promise<typeQaRest[]> => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/qarest/${qano}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => res)
  return res
}

//023 QA基本情報変更,QAレスポンス登録 完了
export const putQaRest = async (userid: string, token: string, role: string, qano: string, form: typeUpdateForm): Promise<number> => {
  //valueに値がない場合はformから削除
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'answerContents' || key === 'note') {
        if (value.match(/^(\r\n|\n|\r)+$/)) {
          obj[key] = value.replace(/(\r\n|\n|\r)+$/, '\r\n')
        } else {
          obj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
        }
      } else {
        obj[key] = value
      }
    }
  }
  //JSON.stringifyでJSON変換時にDateはUTCに自動的に変換される
  let jsonform = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsonform, 'PUT')
  const res = await fetch(`${URL}/qabtrest/${qano}`, header).then(response => {
    if (response.ok) {
      return response.status
    } else {
      throw response
    }
  })
  return res
}

//024 訪問状況取得
export const getVisits = async (userid: string, token: string, role: string, keiyakuno: string) => {
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/visits/${keiyakuno}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {
      return response.json()
    } else {
      throw response
    }
  }).then(res => {
    for (const reso of res) {
      for (const [key, value] of Object.entries(reso)) {//日付フィールドDate型変換
        if (key === 'answeSt') {
          if (value && typeof value === 'string') {
            reso[key] = new Date(value)
          }
        }
      }
    }
    return res
  })
  return res
}

//032 顧客一覧取得
export const getCustomerList = async (userid: string, token: string, role: string, keyword: string): Promise<typeCustomerList[]> => {
  const params = new URLSearchParams()
  params.set('keyWord', keyword)
  const header = GetHeader(userid, token, role)
  const res = await fetch(`${URL}/custms?${params.toString()}`, header).then(response => {
    if (response.status === 204) {
      return []
    } else if (response.ok) {//データが存在する
      return response.json()
    } else {
      throw response
    }
  })
  return res
}

//035 QA基本情報更新
export const putQaContent = async (userid: string, token: string, role: string, form: typeputForm) => {
  //form to JSON
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'relatedQaNo') {
        obj[key] = value.replace(/_/g, '').replace(/ /g, '')
      } else if (key === 'qaContents') {
        obj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
      } else {
        obj[key] = value
      }
    }
  }
  const jsondata = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/qabt/${form.qaNo}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//036 QAレスポンス削除サービス
export const deleteQaRest = async (userid: string, token: string, role: string, qano: string, qaserialno: string): Promise<boolean> => {
  const header = DeleteHeader(userid, token, role)
  const res = await fetch(`${URL}/qarest/${qano}/${qaserialno}`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//059 QAクローズお知らせメール
export const putCloseNotice = async (userid: string, token: string, role: string, qano: string) => {
  //form to JSON
  const obj = {
    qaNo: qano
  }
  const jsondata = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsondata, 'PUT')
  const res = await fetch(`${URL}/closenotice`, header).then(response => {
    if (response.ok) {
      return response.ok
    } else {
      throw response
    }
  })
  return res
}

//066 QAレスポンス更新
export const updateQaRest = async (userid: string, token: string, role: string, qano: string, qaserialno: string, form: typeUpdateForm): Promise<number> => {
  //valueに値がない場合はformから削除
  let obj = {}
  for (const [key, value] of Object.entries(form)) {
    if (value || value === 0) {
      if (key === 'answerContents' || key === 'note') {
        if (value.match(/^(\r\n|\n|\r)+$/)) {
          obj[key] = value.replace(/(\r\n|\n|\r)+$/, '\r\n')
        } else {
          obj[key] = value.replace(/(\r\n|\n|\r)+$/, '').replace(/(\r\n|\n|\r)/g, '\r\n')
        }
      } else {
        obj[key] = value
      }
    }
  }
  //JSON.stringifyでJSON変換時にDateはUTCに自動的に変換される
  let jsonform = JSON.stringify(obj)
  const header = PPHeader(userid, token, role, jsonform, 'PUT')
  const res = await fetch(`${URL}/qarest/${qano}/${qaserialno}`, header).then(response => {
    if (response.ok) {
      return response.status
    } else {
      throw response
    }
  })
  return res
}